// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyV1PharmacyBiDefaultResponseData {
    static getAttributeTypeMap() {
        return PharmacyV1PharmacyBiDefaultResponseData.attributeTypeMap;
    }
}
PharmacyV1PharmacyBiDefaultResponseData.discriminator = undefined;
PharmacyV1PharmacyBiDefaultResponseData.additionalProperties = false;
PharmacyV1PharmacyBiDefaultResponseData.attributeTypeMap = [
    {
        "name": "transactionCorrelationId",
        "baseName": "transactionCorrelationId",
        "type": "number"
    },
];
//# sourceMappingURL=pharmacyV1PharmacyBiDefaultResponseData.js.map